export class WebhookV1StandardPayloadNotificationTargetChange {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadNotificationTargetChangeTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadNotificationTargetChangeArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadNotificationTargetChange.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadNotificationTargetChangeTypeEnum;
(function (WebhookV1StandardPayloadNotificationTargetChangeTypeEnum) {
    WebhookV1StandardPayloadNotificationTargetChangeTypeEnum["Created"] = "NOTIFICATION_TARGET_CREATED";
    WebhookV1StandardPayloadNotificationTargetChangeTypeEnum["Updated"] = "NOTIFICATION_TARGET_UPDATED";
    WebhookV1StandardPayloadNotificationTargetChangeTypeEnum["Deleted"] = "NOTIFICATION_TARGET_DELETED";
    WebhookV1StandardPayloadNotificationTargetChangeTypeEnum["Enabled"] = "NOTIFICATION_TARGET_ENABLED";
    WebhookV1StandardPayloadNotificationTargetChangeTypeEnum["Disabled"] = "NOTIFICATION_TARGET_DISABLED";
})(WebhookV1StandardPayloadNotificationTargetChangeTypeEnum || (WebhookV1StandardPayloadNotificationTargetChangeTypeEnum = {}));
